import { apiClient, Auth, PaginationSearchParams } from '@/shared/api'

import { THostPayReady } from '../model/schema'

const DEFAULT_SIZE = 20

export type HostPayReadySearchParams = PaginationSearchParams & {
  onlySummary?: boolean
  rid?: string
}

export const getHostPayReady = async (
  params: HostPayReadySearchParams = {},
) => {
  const { data } = await apiClient.get<THostPayReady>({
    endpoint: `/settlements/ready`,
    auth: Auth.REQUIRED,
    queryParams: {
      ...params,
      size: params.size ?? DEFAULT_SIZE,
    },
  })

  return data
}
